import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from '../component/layouts/dashboard/dashboard.component';
import { AuthGuard } from '../shared/auth.guard';
import { PermissionGuard } from '../shared/permission.guard';
import { InvoicingListComponent } from './invoicing-list/invoicing-list.component';
import { InvoicingNewComponent } from './invoicing-new/invoicing-new.component';
import { InvoicingWarehouseComponent } from './invoicing-warehouse/invoicing-warehouse.component';
import { InvoicingWarehouseNewComponent } from './invoicing-warehouse-new/invoicing-warehouse-new.component';

const routes: Routes = [{
    path: 'invoicing',
    component: DashboardComponent,
    canActivate: [AuthGuard, PermissionGuard],
    children: [{
        path: 'list',
        component: InvoicingListComponent,
        data: { module: 'Facturación', accion: 'Listado de Facturas', type: 'list' }
    }, {
        path: 'new',
        component: InvoicingNewComponent,
        data: { module: 'Facturación', accion: 'Nueva Factura', type: 'new' }
    }, {
        path: 'warehouse',
        component: InvoicingWarehouseComponent,
        data: { module: 'Facturas de almacén', accion: 'Listado de Facturas', type: 'list' }
    }, {
        // El módulo lleva las dos primeras migas: la cabecera pinta
        // `module / accion` y el diseño pide "Facturación / Facturación de
        // almacén / Crear factura".
        path: 'warehouse/new',
        component: InvoicingWarehouseNewComponent,
        data: { module: 'Facturación / Facturación de almacén', accion: 'Crear factura', type: 'new' }
    }]
}];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class InvoicingRoutingModule { }
